<template>
    <div>
<!--        The webhook belonging to <strong>{{ $_.get(activity, "actorUser.name") }}</strong> was removed by-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>.-->
<!--        Kontrol edilecek (User2 yok)-->
        <span v-html="$t('notification.webhookRemoved', { user1: $_.get(activity, 'actorUser.name'), user2: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WebHookRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
